import React from "react"

const FormLabel = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="form-label">{children}</label>
)

export default FormLabel
